<section
  class="flex flex-col theme-wrapper theme-border rounded-md p-4 select-none bg-white"
>
  <ng-container *ngTemplateOutlet="header" />
  <ng-container *ngTemplateOutlet="daySection" />
</section>

<ng-template #header>
  <section class="relative flex w-full items-center justify-between mb-3 gap-2">
    <app-calendar-label [value]="date()!" (dateChange)="handleEvent($event)" />

    <div class="flex gap-3 items-center">
      <app-icon-button
        (click)="handleNavigate('prev', 'month', 1)"
        icon="ic:baseline-chevron-left"
      />
      <app-icon-button
        (click)="handleNavigate('next', 'month', 1)"
        icon="ic:baseline-chevron-right"
      />
    </div>
  </section>
</ng-template>

<ng-template #daySection>
  <section class="flex flex-col">
    <div class="grid grid-cols-7 w-full">
      <p class="item text-red-600">일</p>
      <p class="item">월</p>
      <p class="item">화</p>
      <p class="item">수</p>
      <p class="item">목</p>
      <p class="item">금</p>
      <p class="item text-blue-600">토</p>
    </div>
    <div class="grid grid-cols-7 w-full">
      @for (day of days(); track $index) {
        <app-range-day
          (click)="handleClick(day)"
          [start]="start()!"
          [end]="end()!"
          [day]="day"
          [currentDate]="date()!"
        />
      }
    </div>
  </section>
</ng-template>
